export default __webpack_public_path__ + "static/corner_interface-c7ccda6e778b1bedf3eec91e48111e27.png";